import { AuditedQueryDTO, IDapperReadDeleteEntityService } from '@digiwall/core';
import { DwGridDataSourceService, FieldTypes } from '@digiwall/ag-grid';
import { BaseThirdPartyDocList } from '../base-third-party-docs/base-third-party-doc-list';
import { Injector } from '@angular/core';
import { ColDef } from '@ag-grid-community/core';
import { LocalizationService, SubscriptionService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { Router, ActivatedRoute } from '@angular/router';

export abstract class BaseSupplierDocList<
  TEntityListDto extends AuditedQueryDTO<string>,
  DocService extends IDapperReadDeleteEntityService<TEntityListDto>,
> extends BaseThirdPartyDocList<TEntityListDto, DocService> {
  constructor(
    docService: DocService,
    router: Router,
    route: ActivatedRoute,
    confirmation: ConfirmationService,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      docService,
      router,
      route,
      confirmation,
      localizationService,
      subscriptionService,
      datasource,
      injector,
    );
    const labels: { [id: string]: string } = {
      thirdPartyCode: 'Doc::Supplier:Code',
      thirdPartyName: 'Doc::Supplier:Name',
      thirdPartyAddress: 'Doc::Supplier:Address',
      thirdPartyPostalCode: 'Doc::Supplier:PostalCode',
      thirdPartyLocality: 'Doc::Supplier:Locality',
      salesPerson: 'Doc::Supplier:SalePerson',
    };

    Object.keys(labels).forEach(labelKey => {
      this.colDefs.find(col => col.field == labelKey).headerName = this.localizationService.instant(
        labels[labelKey],
      );
    });
  }

  override colDefs: ColDef[] = [
    ...this.colDefs,
    {
      field: 'supplierDocOriginId',
      headerName: this.localizationService.instant('::DocOrigin'),
      type: FieldTypes.String,
      hide: true,
    },
  ];
}
